import React, { Component } from 'react';

//componentes
import ReferenciaPago from './referenciaPago'

class Index extends Component {

    render(){
        return(
            <div>
                <ReferenciaPago />
            </div>
        );
    }

}
export default Index;